<script setup lang="ts">
import type { SubmitEventPromise } from 'vuetify';

import { reactive, ref, toRaw } from 'vue';

import MonthPickerField from '@/components/pickerFields/MonthPickerField.vue';
import useForm from '@/composables/useForm';
import { requiredValidationRule } from '@/helpers/validationRules';

export interface InitialData {
  date?: string;
}

export interface ValidData {
  date: string;
}

export interface Props {
  loading?: boolean;
  initialData?: InitialData;
}
const props = withDefaults(defineProps<Props>(), {
  loading: false,
  initialData: () => ({}),
});
const emit = defineEmits<{
  submit: [event: SubmitEventPromise | null | undefined, formData: ValidData];
}>();

const formData = reactive<InitialData>({});
const isValid = ref(true);

const { form, handleSubmit } = useForm(props, formData, function (event) {
  emit('submit', event, toRaw(formData) as ValidData);
});
</script>

<template>
  <v-form
    ref="form"
    v-model="isValid"
    validate-on="lazy"
    :class="$style.kpiReportGenerateDialogForm"
    data-testid="kpiReportGenerateDialogForm"
    @submit.prevent="handleSubmit"
  >
    <MonthPickerField
      v-model="formData.date"
      label="Date range"
      :disabled="props.loading"
      :rules="[requiredValidationRule]"
      :class="$style.field"
      hide-details
    />
    <input type="submit" class="hidden" :disabled="props.loading" />
  </v-form>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.kpiReportGenerateDialogForm {
}
  .field {
  }
</style>
